import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationsComponent } from './applications/applications.component';
import { EmployeesComponent } from './employees.component';
import { ProductStoreRolesComponent } from './product-store-roles/product-store-roles.component';
import { ResumesComponent } from './resumes/resumes.component';
import { SkillsComponent } from './skills/skills.component';



@NgModule({
  declarations: [
    EmployeesComponent,
    SkillsComponent,
    ResumesComponent,
    ApplicationsComponent,
    ProductStoreRolesComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class EmployeeModule { }
